import dark from "@/data/dark.js"
import light from "@/data/light.js"
import gold from "@/data/gold.js"

export default {
    "dark-theme":dark,
    "light-theme":light,
    "gold-theme":gold
}